import { HeaderContext } from '../context'
import React, { useCallback } from 'react'
import { Breadcrumb } from '../../../Elements/Header/Breadcrumbs'

interface useProviderBreadcrumbsHook {
  breadcrumbs: Breadcrumb[]
  setBreadcrumbs: (value: Breadcrumb[]) => void
}

export const useHeaderBreadcrumbs = (): useProviderBreadcrumbsHook => {
  const contextValue = React.useContext(HeaderContext)

  if (contextValue === undefined) {
    throw new Error('useHeaderBreadcrumbs must be used within HeaderProvider')
  }

  const setBreadcrumbs = useCallback(
    (value: Breadcrumb[]): void => contextValue?.setBreadcrumbs(value),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contextValue.setBreadcrumbs]
  )

  return { breadcrumbs: contextValue.breadcrumbs, setBreadcrumbs }
}
